let CocosEvent = require("cocos/framework/components/event")
let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchConst = require("activity/CoinMatchActivity/CoinMatchConst")

const RewardType = CoinMatchConst.RewardType
const AdType = CoinMatchConst.AdType
const InviteRewardStatus = CoinMatchConst.InviteRewardStatus

CoinMatchManager = xClass("CoinMatchManager", CocosEvent)

const LAYOUT = "meta/activity/coin_match_layout.json";
const CONFIG_NAME = "coin_match";

// 按键当日点击标识
const ICON_CLICK_TODAY_SETTINGKEY = "hasClickCoinMatchToday";

// 当日主面板打开标识
const SHOW_MAIN_TODAY_SETTINGKEY = "CoinMatchMainShowDay";

const CoinMatchEvent = {
    kFinalRewardGain: "CoinMatchEvent.kFinalRewardGain",    // 收取最终奖励
    kStepChanged: "CoinMatchEvent.kStepChanged",    // 步数信息变更
    kReset: "CoinMatchEvent.kReset",    // 重置
}

CoinMatchManager.prototype.ctor = function () {
    this.bind(this)
    this.info = null;

    this.finalRewardList = null;
    this.finalRewardType = null;
    this.gainRewardList = null;

    this.boxRewardList = null;

    this.levelIndex = null;
    GameplayEventDispatcher.getInstance().on(GameplayEvent.UseMove, (evt) => this.updateLevel(evt.leftMoves));

    this.inviteRewardCount = 0;
    this.canGetStepReward = false;

    this.levelRecord = null;    // 游戏记录

    this.hasOpenMoreStepPanel = false;
}

CoinMatchManager.prototype.startLevel = function(levelId) {
    cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD);
    this.levelRecord = {
        levelId: levelId,
        isWin: false,
        passTime: Localhost.time(),
        adStep: 0,
        useStep: 0,
        lastMoveStep: this.info.leftStep
    }
}

CoinMatchManager.prototype.updateLevel = function(leftMoves) {
    if (this.levelRecord != null && leftMoves < this.levelRecord.lastMoveStep) {
        this.levelRecord.useStep += this.levelRecord.lastMoveStep - leftMoves;
        this.levelRecord.lastMoveStep = leftMoves;
        this.levelRecord.passTime = Localhost.time();
        cc.UserDefault.getInstance().setStringForKey(LOCAL_LAST_COIN_MATCH_RECORD, JSON.stringify(this.levelRecord));
    }
}

CoinMatchManager.prototype.adStepInLevel = function(addStep) {
    if (this.levelRecord != null) {
        this.levelRecord.adStep += addStep;
        this.levelRecord.lastMoveStep += addStep;
        this.levelRecord.passTime = Localhost.time();
        cc.UserDefault.getInstance().setStringForKey(LOCAL_LAST_COIN_MATCH_RECORD, JSON.stringify(this.levelRecord));
    }
}

CoinMatchManager.prototype.endLevel = function () {    
    this.info.leftStep = this.levelRecord.lastMoveStep;
    if (this.levelRecord.isWin) 
        this.levelIndex += 1;
        
    this.levelRecord = null;
}

CoinMatchManager.prototype.active = function() {
    let checkPermanentRes = ()=> {
        if (CoinMatchConfig.permanentResList.length == 0)
            return Promise.resolve();
    
        let unloadRes = [];
        for (let i = 0; i < CoinMatchConfig.permanentResList.length; i++) {
            let res = CoinMatchConfig.permanentResList[i];
            if (ResManager.get(res) == null)
                unloadRes.push(res);
            else
                ResManager.persist(res);
        }
        if (unloadRes.length == 0)
            return Promise.resolve();

        return new Promise((resolve, reject) => {
            ResManager.load(CoinMatchConfig.permanentResList)
                .then(() => {
                    ResManager.persist(CoinMatchConfig.permanentResList);
                    resolve();
                })
                .catch(reject);
        });
    }

    let loadDataFromServer = (force)=> {
        return new Promise((resolve, reject)=> {
            this.loadDataFromServer(force, resolve, reject);
        });
    }

    if (CoinMatchConfig.inited) {
        return Promise.all([checkPermanentRes(), loadDataFromServer(false)]);
    } else {       
        return new Promise((resolve, reject) => { 
            Promise.all([
                CfgManager.load(CONFIG_NAME), 
                ResManager.load(LAYOUT)])
                .then(() => {
                    let config = CfgManager.get(CONFIG_NAME);
                    let layout = ResManager.get(LAYOUT);

                    CoinMatchConfig.init(config, layout);
                    CfgManager.release(CONFIG_NAME);

                    Promise.all([
                        checkPermanentRes(), 
                        loadDataFromServer(true)])
                        .then(resolve).catch(reject);
                })
                .catch((err) => {
                    console.error("CoinMatch active failed!", err);
                    reject(err);
                }); 
        });
    }      
}

CoinMatchManager.prototype.loadDataFromServer = function (force, onSuccess, onFail) {
    force = true;   // 要求修改成每次进入都刷新
    if (!force && this.info != null) {
        if (onSuccess != null)
            onSuccess(this.info);
        return;
    }
    
    let success = (evt)=> {
        this.updateData(evt.data);
        if (onSuccess != null)
            onSuccess(this.info);
    }

    let fail = (evt)=> {
        if (onFail != null)
            onFail(evt.data);
    }

    let http = CoinMatchActivityInfoHttp.new();
    http.addEventListener(Events.kComplete, success);
    http.addEventListener(Events.kError, fail);
    http.addEventListener(Events.kCancel, fail);
    http.load();
}

CoinMatchManager.prototype.hasClickToday = function() {
    return UserLocalSettings.getSetting(ICON_CLICK_TODAY_SETTINGKEY, 0) == Localhost.timeInDay();
}

CoinMatchManager.prototype.setClickToday = function() {
    UserLocalSettings.setSetting(ICON_CLICK_TODAY_SETTINGKEY, Localhost.timeInDay());
}

CoinMatchManager.prototype.hasShowMainToday = function() {
    return UserLocalSettings.getSetting(SHOW_MAIN_TODAY_SETTINGKEY, 0) == Localhost.timeInDay();
}

CoinMatchManager.prototype.setShowMainToday = function() {
    UserLocalSettings.setSetting(SHOW_MAIN_TODAY_SETTINGKEY, Localhost.timeInDay());
}

CoinMatchManager.prototype.hasFinalReward = function() {
    return this.finalRewardType != null;
}

CoinMatchManager.prototype.getFinalReward = function() {
    return [this.finalRewardType, this.finalRewardList];
}

CoinMatchManager.prototype.hasFinishAllLevel = function () {
    return this.levelIndex == this.getLevelIds().length;
}

CoinMatchManager.prototype.getCurrentLevelStep = function () {
    return this.levelIndex + 1;
}

CoinMatchManager.prototype.getPassedLevelStep = function () {
    return this.levelIndex;
}

/**
 * 获取已经领取的最终奖励
 */
CoinMatchManager.prototype.getGainFinalReward = function() {
    return this.gainRewardList;
}

/**
 * 剩余可重置次数
 */
CoinMatchManager.prototype.getResetRemainTimes = function() {
    return this.info.resetLeftCount;
}

/**
 * 获取剩余步数
 */
CoinMatchManager.prototype.getLeftStep = function() {
    return this.info.leftStep;
}

/**
 * 获取宝箱奖励
 */
CoinMatchManager.prototype.getBoxRewards = function() {
    return this.boxRewardList;
}

/**
 * 获取当前关卡号
 */
CoinMatchManager.prototype.getLevelId = function() {
    return this.getLevelIds()[this.levelIndex];
}

/**
 * 是否可以领取好友邀请奖励
 */
CoinMatchManager.prototype.canGetInviteReward = function() {
    return this.canGetStepReward || this.inviteRewardCount > 0;
}
/**
 * 获取剩余关卡数量
 */
CoinMatchManager.prototype.getLeftLevel = function() {
    return $len(this.getLevelIds()) - this.levelIndex;
}
CoinMatchManager.prototype.getLevelIds = function() {
    if(this.levelArray && this.levelArray.length > 0){
        return this.levelArray;
    }
    return CoinMatchConfig.values.levelIds;
}
CoinMatchManager.prototype.updateData = function(serverCoinMathData) {
    let evtList = [];
    let fields = ["leftStep", "resetLeftCount", "extraSteps", "moreStepsNum", "failStepsNum"];
    if (this.info == null) 
        this.info = {};
    fields.forEach((field) => this.info[field] = serverCoinMathData[field]);
    
    let finalRewardList = $tableToArray(serverCoinMathData["finalReward"]), finalRewardType = null;
    if (finalRewardList.length > 0)
        finalRewardType = RewardType.FinalReward;
    else {
        finalRewardList = $tableToArray(serverCoinMathData["lastReward"]);
        if (finalRewardList.length > 0)
            finalRewardType = RewardType.LastReward;
    }
        
    this.finalRewardList = finalRewardList;
    this.finalRewardType = finalRewardType;
    
    this.gainRewardList = null;


    this.levelArray = [];
    for (let i = 0; i < serverCoinMathData.levelArray.length; i++) {
        let conf = serverCoinMathData.levelArray[i];
        if (conf)this.levelArray.push(conf);     
    }
    


    let levelId = serverCoinMathData.levelId;
    let levelIndex = this.getLevelIds().indexOf(levelId);
    // let levelIndex = serverCoinMathData.levelIndex || 0; //当前关卡进度不在自己判断 改为由服务端下发

    if (levelIndex < 0)
        levelIndex =  this.getLevelIds().length;
    if (this.levelIndex != levelIndex) {
        this.levelIndex = levelIndex;
    }

    if (this.boxRewardList == null)
        this.boxRewardList = getBoxRewards(this);

    this.canGetStepReward = serverCoinMathData["canGetStepReward"];
    evtList.forEach((e) => this.dispatchEvent(e));
}

function getBoxRewards(self) {
    let rewardsConfig = CoinMatchConfig.values.levelRewards;
    let levelIds = self.getLevelIds();
    
    let rewards = [];
    
    for (let i = 0; i < levelIds.length; i++) {
        let config = rewardsConfig[i];
        if (config != null) {
            let item = {};
            Object.assign(item, config);
            item.lvStep = i + 1;
            item.itemId = parseInt(item.itemId);
            rewards.push(item);
        }
    }
    
    return rewards;
}

CoinMatchManager.prototype.getRewardPromise = function(rewardType, useMask = true, extendData = null) {
    return new Promise((resolve, reject)=> {
        let fail = (evt)=>  reject(evt.data);
        
        let success = (evt)=> {
            let evtList = null;
            if (rewardType == RewardType.FinalReward) {
                this.gainRewardList = this.finalRewardList;
                this.finalRewardList = null;
                this.finalRewardType = null;   
                evtList = [{ name: CoinMatchEvent.kFinalRewardGain }];
            } else if (rewardType == RewardType.Invite) {
                let oldLeftStep = this.info.leftStep;
                this.info.leftStep = evt.data.leftStep;
                this.info.extraSteps += (this.info.leftStep - oldLeftStep);
                evtList = [{ name: CoinMatchEvent.kStepChanged }];

                for (let i = 0; i < this.inviteList.length; i++) {
                    let v = this.inviteList[i];
                    if (v.index == extendData) {
                        v.canGet = InviteRewardStatus.kRewarded;
                        this.inviteRewardCount--;
                        if (this.inviteRewardCount == 0)
                            this.canGetStepReward = fail;
                        break;
                    }
                }
            }
            
            resolve();

            if (evtList != null) 
                evtList.forEach((evt)=> this.dispatchEvent(evt));
        }
        
        let http = CoinMatchGetRewardHttp.new(useMask);
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, fail);
        http.addEventListener(Events.kCancel, fail);
        http.load(rewardType, rewardType == RewardType.Invite? extendData: null);
    });    
}

CoinMatchManager.prototype.getInviteRewardPromise = function(inviteIndex, useMask = true) {
    return this.getRewardPromise(RewardType.Invite, useMask, inviteIndex);
}

CoinMatchManager.prototype.getInviteList = function() {
    return this.inviteList;
}

CoinMatchManager.prototype.updateInviteData = function (inviteDataFromServer) {        
    let list = $tableToArray(inviteDataFromServer.list);
    let defaultReward = inviteDataFromServer.reward.defaultReward;
    let reward = inviteDataFromServer.reward;
    let length = Math.max(list.length, CoinMatchConfig.values.inviteMax);

    let rewardCount = 0;
    for (let i = 0; i < list.length; i++) {
        if (list[i].canGet == InviteRewardStatus.kCanGet)
            ++rewardCount;
    }
    for (let i = list.length; i< length; i++) {
        let specialReward = reward[i + 1];
        let invitedItem =  {
            canGet: InviteRewardStatus.kCannotGet,
            index: i + 1,
            step: specialReward == null? defaultReward: specialReward
        }
        list.push(invitedItem);
    }

    this.inviteList = list;
    this.inviteRewardCount = rewardCount;
    this.defaultReward = defaultReward;
    if (this.inviteRewardCount == 0)
        this.canGetStepReward = false;
}

CoinMatchManager.prototype.getInvitedInfoFromServer = function () {
    return new Promise((resolve, reject) => {
        let success = (evt)=> {
            let invitedInfo = evt.data;
            this.updateInviteData(invitedInfo);
            resolve();
        }
        let http = CoinMatchInvitedInfoHttp.new();
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, (evt) => {
            reject(evt.data)
        });
        http.addEventListener(Events.kCancel, () => {
            reject(0);
        });
        http.load();
    })
}

CoinMatchManager.prototype.getExtraSteps = function() {
    return this.info.extraSteps;
}

CoinMatchManager.prototype.getDefaultInviteStep = function() {
    return this.defaultReward;
}

CoinMatchManager.prototype.getMoreStepsNum = function() {
    return this.info.moreStepsNum;
}

CoinMatchManager.prototype.getFailStepsNum = function() {
    return this.info.failStepsNum
}

CoinMatchManager.prototype.watchAd = function(type, onSuccess, onFail) {
    let retry = 2;

    let success = (evt) => {
        let addStep = evt.data.addStep;

        if (type == AdType.kMoreStep) {            
            this.info.moreStepsNum += 1;            
            this.info.extraSteps += addStep;
            this.info.leftStep += addStep;
        } else if (type == AdType.kFail) {
            this.info.failStepsNum += 1;
        }

        if(onSuccess != null)
            onSuccess(addStep);
            
        if (type == AdType.kMoreStep) {           
            this.dispatchEvent({ name: CoinMatchEvent.kStepChanged });
        } else if (type == AdType.kFail) {
            this.adStepInLevel(addStep);
        }
    }

    let fail = (evt) => {
        // 延迟 100 毫秒，以避免网络不稳定
        setTimeout(() => {
            if (--retry < 0) {
                if (onFail) {
                    onFail(evt == null? 0: evt.data);
                }
            } else {
                httpCall();
            }
        }, 100);
    }
    
    function httpCall() {
        let http = CoinMatchWatchAdHttp.new();
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, fail);
        http.addEventListener(Events.kCancel, fail);
        http.load(type);
    }

    httpCall();  
}
/**
 * 关卡内好友成功帮助加步数
 */
CoinMatchManager.prototype.friendShare = function() {
    this.levelRecord.lastMoveStep += this.getShareAddStepNum()
}

CoinMatchManager.prototype.reset = function(onSuccess, onFail) {
    let retry = 2;

    let success = (evt) => {
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD);
        this.updateData(evt.data);

        if (onSuccess != null)
            onSuccess();
        
        this.dispatchEvent({ name: CoinMatchEvent.kReset });
    }

    let fail = (evt) => {
        // 延迟 100 毫秒，以避免网络不稳定
        setTimeout(() => {
            if (--retry < 0) {
                if (onFail) {
                    onFail(evt == null? 0: evt.data);
                }
            } else {
                httpCall();
            }
        }, 100);
    }
    
    function httpCall() {
        let http = CoinMatchActivityResetHttp.new();
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, fail);
        http.addEventListener(Events.kCancel, fail);
        http.load();
    }

    httpCall();  
}

/**
 * 处理上一次关卡数据
 */
CoinMatchManager.prototype.dealLastLevelRecord = function () {
    let record = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_COIN_MATCH_RECORD);
    if (record == null || record.length == 0) {
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD)
        return Promise.resolve();
    }

    try {
        record = JSON.parse(record);
    } catch (error) {
        console.error("parse LOCAL_LAST_COIN_MATCH_RECORD json failed", cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_COIN_MATCH_RECORD), error);
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD);
        return Promise.resolve();
    }
    
    if (record == null) {
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD)
        return Promise.resolve();
    }
    if (record != null &&
        typeof record.levelId === "number" &&   
        typeof record.isWin !== "undefined" &&
        typeof record.passTime === "number" && 
        typeof record.adStep === "number" && 
        typeof record.useStep === "number" && 
        typeof record.lastMoveStep === "number" &&
        record.passTime >= CoinMatchConfig.values.startTime * 1000 && 
        record.passTime < (CoinMatchConfig.values.endTime + 1) * 1000 &&
        record.useStep > 0 &&
        (record.isWin === true || record.isWin === "true")) {
        return new Promise((resolve, reject) => {
            let http = CoinMatchPassLevelHttp.new()
            http.addEventListener(Events.kComplete, 
                () => {
                    cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD);
                    if (record.isWin)
                        this.dealReward(record.levelId);
                    resolve();
                }
            );
            http.addEventListener(Events.kError, (evt) => {
                Toast.make(quickGetErrorText(evt.data, getText("coin.match.share.fail")))
                resolve()
            })
            http.load(record.useStep, record.levelId, record.isWin, record.passTime);
        });
    } else {
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD);
        return Promise.resolve();
    }
}

CoinMatchManager.prototype.dealReward = function(levelId) {
    let levelIndex = this.getLevelIds().indexOf(levelId);
    if (levelIndex == this.levelIndex - 1) {
        for(let i = this.boxRewardList.length - 1; i >= 0; i--) {
            let reward = this.boxRewardList[i];
            if (reward.lvStep == levelIndex + 1) {
                UserProp.getInstance().rewardProp(reward.itemId, reward.num, null, null, ModuleName.COIN_MATCH_ACTIVITY);
                return;
            }
        }
    }
    
}

/**
 * 发送通关信息
 */
CoinMatchManager.prototype.sendPassLevelDate2Server = function (isWin) {
    let self = this;

    return new Promise((resolve, reject) => {
        self.levelRecord.isWin = isWin;
        self.levelRecord.passTime = Localhost.time();
        cc.UserDefault.getInstance().setStringForKey(LOCAL_LAST_COIN_MATCH_RECORD, JSON.stringify(self.levelRecord));

        let levelId = self.levelRecord.levelId;
        let called = false
        function onSuccess() {
            if (called) {
                return
            }
            called = true
            removeAnim()
            cc.UserDefault.getInstance().removeKey(LOCAL_LAST_COIN_MATCH_RECORD)
            self.endLevel();
            if (isWin)
                self.dealReward(levelId)
            resolve()
        }
        
        function onFail(evt) {
            if (called) {
                return
            }
            called = true
            removeAnim()
            self.endLevel();
            reject(evt && evt.data || 0)
        }

        function removeAnim() {
            if (loadId) {
                LoadingPanelLogic.getInstance().remove(loadId)
                load = null
            }
        }
        let loadId = LoadingPanelLogic.getInstance().add(null, function () {
            onFail()
        })

        let http = CoinMatchPassLevelHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.load(self.levelRecord.useStep, self.levelRecord.levelId, self.levelRecord.isWin, self.levelRecord.passTime);
    })
}

/**
 * 是否可以看广告
 */
CoinMatchManager.prototype.canWatchAd = function () {
    var self = this
    //  检查是否可以看广告
    if (CoinMatchConfig.values.adLevelLimit >= 0 && self.getFailStepsNum() >= CoinMatchConfig.values.adLevelLimit) {
        return false;
    } else {
        //  可以看广告
        return true;
    }
}
/**
 * 获取看广告加步数量
 */
CoinMatchManager.prototype.getFreeAddStepNum = function () {
    return CoinMatchConfig.values.adLevelStep;
}
/**
 * 获取分享加步数量
 */
CoinMatchManager.prototype.getShareAddStepNum = function () {
    return CoinMatchConfig.values.askforhelp_succeed;
}

CoinMatchManager.prototype.setHasOpenMoreStepPanel = function(f){
    this.hasOpenMoreStepPanel = f;
}

CoinMatchManager.prototype.getHasOpenMoreStepPanel = function(f){
    return this.hasOpenMoreStepPanel;
}

let _instance = null
CoinMatchManager.getInstance = function () {
    if (!_instance) {
        _instance = CoinMatchManager.new()
    }
    return _instance
}

CoinMatchManager.EventEnum = CoinMatchEvent
module.exports = CoinMatchManager